import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import AdvisorContactInfo from './AdvisorContactInfo/AdvisorContactInfo'
import styles from './WelcomeNotification.module.scss'
import { BaseComponent } from 'belle-js'
import { formatDate } from 'utils/systemUtils'
import {
  updateNotificationUserDismissed
} from 'utils/Client/apiRequest'

class WelcomeNotification extends BaseComponent {

  constructor (props) {
    super(props)

    this.state = {}

    this.bind('onUserDismiss')
  }

  getAuthor (id) {
    return this.props.teamMembers.find(member => member.id === id)
  }

  showNotification (isActive, userDismissed) {
    if (isActive && !userDismissed) {
      return true
    }

    if (!isActive || (isActive && userDismissed)) {
      return false
    }
  }

  onUserDismiss (notificationId) {
    const { setNotificationUserDismissed } = this.props
    const bodyRequest = { notification: { user_dismissed: true } }

    try {
      updateNotificationUserDismissed(notificationId, bodyRequest)
    } catch (e) {
      return false
    }

    setNotificationUserDismissed(notificationId)
  }

  renderNotifications () {
    const { notifications, isMobile } = this.props

    return notifications.map(notification => (
      <Fragment key={notification.id} > {
        this.showNotification(notification.isActive, notification.userDismissed) &&
        <div className={styles.container}>
          <div className={styles.background}>
            <div className={styles.row}>
              <div className={styles.messageColumn}>
                <div className={styles.date}>
                  {formatDate(notification.createdDate, 'short')}
                </div>
                <div className={styles.header}>
                  {notification.name}
                </div>
                <p className={styles.body}>
                  {notification.messageBody}
                </p>
                <p className={styles.author}>
                   &#45;{this.getAuthor(notification.authorId).firstName}
                </p>
                <div className={styles.divider} />
              </div>
              <div className={styles.contactColumn}>
                <AdvisorContactInfo
                  isMobile={isMobile}
                  contact={this.getAuthor(notification.authorId)} />
              </div>
            </div>
            <img
              src="images/close.png"
              alt="close"
              className={styles.close}
              onClick={() => this.onUserDismiss(notification.id)} />
            <img
              src="images/close_mobile.png"
              alt="close"
              className={styles.closeMobile}
              onClick={() => this.onUserDismiss(notification.id)} />
          </div>
        </div>
      }
      </Fragment>
    ))
  }

  render () {
    return (
      <Fragment>
        {this.renderNotifications()}
      </Fragment>
    )
  }

}

WelcomeNotification.defaultProps = {
  isMobile: false
}

WelcomeNotification.propTypes = {
  teamMembers: PropTypes.array.isRequired,
  notifications: PropTypes.array.isRequired,
  setNotificationUserDismissed: PropTypes.func.isRequired,
  isMobile: PropTypes.bool
}

export default WelcomeNotification



// WEBPACK FOOTER //
// ./src/components/Client/WelcomeNotification/WelcomeNotification.jsx